import {
    type DeleteNotificationResponseType,
    type DeleteNotificationRequestType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const DeleteNotification = async (params: DeleteNotificationRequestType): Promise<DeleteNotificationResponseType> => {
    return await axios(`${SERVER_ADDRESS}/notification/deleteNotification`, {
        headers: getHeaders(true),
        method: "POST",
        data: params
    })
        .then((res) => {
            if(
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if(err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};

export default DeleteNotification;
